module.exports = __webpack_public_path__ + "static/media/Ozruk.cc9301bb.md";